module.exports = __webpack_public_path__ + "static/img/mid-bar1.5339720.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/buyone365/mid-bar1.jpg
// module id = 6TIN
// module chunks = 0